<template>
    <div>
        <TableList ref="tableList" v-bind="getData"></TableList>
    </div>
</template>

<script>
import { HttpPlanBillErpSku } from "@/service/transferplan";
import TableList from "@components/templates/tablelist";
import { mapState, mapGetters } from "vuex";
export default {
    props: ['lineId'],
    components: {
        TableList,
    },
    data() {
        return {};
    },
    computed: {
        ...mapGetters("dictionary", ["getProductList"]),
        getData() {
            return {
                initFormData: {
                	search:{
                        // 'EQ_lineId': this.lineId || null
                		// 'EQ_orderNo':'',
                		// 'EQ_lineId':this.parentFormDatas.lineId,
                		// 'EQ_currencyCode':this.parentFormDatas.currency,
                		// 'EQ_orderClass':this.parentType.toLowerCase(),
                		// 'EQ_customerId':this.parentType=='B2B'?this.parentFormDatas.customerId:'',
                		// 'EQ_channelId':this.parentType=='B2C'?this.parentFormDatas.channelId:'',
                	}
                },
                ajaxRequest: HttpPlanBillErpSku,
                interceptRequest: (params) => {
                    return {
                        ...params,
                        search: {
                            ...params.search,
                            'EQ_lineId': this.lineId || null
                        },
                    };
                },
                startUp: true,
                Searchs: {
                    show: true,
                    style: "border:none;",
                    // labelWidth: 'auto',
                    align: "left",
                },
                SearchsData: [
                    {
                        label: "SKU",
                        tag: "vInput",
                        key: "CN_sku",
                        style: "width: 160px",
                        show: true,
                    },
                    {
                        label: "名称",
                        tag: "vInput",
                        key: "CN_name",
                        style: "width:160px",
                        show: true,
                    },
                    // {
                    //     label: "项目",
                    //     tag: "Select",
                    //     options: this.getProductList,
                    //     key: "EQ_lineId",
                    //     style: "width: 160px",
                    //     show: true
                    // },
                ],
                columns: [
                    {
                        title: "SKU",
                        key: "sku"
                    },
                    {
                        title: "名称",
                        key: "name"
                    },
                    // {
                    //     title: "可用库存",
                    //     key: "inventoryAvailable"
                    // },
                    {
                        title: "操作",
                        align: "center",
                        width: 80,
                        render: (h, { row }) => {
                            return (
                                <div>
                                    <Button size="small" type="primary" onClick={this.handleSelect.bind(this, row)}>选择</Button>
                                </div>
                            );
                        },
                    },
                ],
            };
        },
    },
    methods: {
        handleSelect (item) {
            this.$emit('on-select', item);
            this.$emit('on-close');
        }
    }
};
</script>

<style>
</style>